export default __webpack_public_path__ + "static/top_mv_sp-904264b866969bda2c6455ee0500d113.jpg";